import styled from "@emotion/styled";
import theme from "@theme/";

const Label = styled.div`
  display: flex;
  text-align: left;
  flex: 0.4;
  font-family: "Charlie Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 4px;

  @media (max-width: 768px) {
    font-size: 13px;
    flex: 1;
  }
`;

const Astrik = styled.span`
  color: #ef4444;
  margin-left: 2px;
`;

const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 16px 20px;
  margin-bottom: 12px;
  border-bottom: 1px solid rgba(227, 110, 0, 0.1);

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 16px;
  }
`;

const Children = styled.div`
  flex: 2;

  @media (max-width: 768px) {
    flex: 1;
    width: 100%;
  }
`;

const Wrapper = styled.div`
  display: flex;
  padding: 0px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ReportContainer = styled.div`
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  border-radius: 20px;
  padding: 32px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  margin: 20px;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
  }

  @media (max-width: 768px) {
    padding: 24px;
    margin: 15px;
    width: calc(100% - 30px);
  }
`;

const ResponsiveButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  margin: 24px 0 0 0;
  flex-wrap: wrap;
  justify-content: flex-start;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    margin-left: 0;
    width: 100%;
  }
`;

const StyledButton = styled.button`
  background: linear-gradient(135deg, #e36e00 0%, #ffae00 100%);
  min-width: 200px;
  height: 48px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  color: white;
  border: none;
  box-shadow: 0 4px 15px rgba(227, 110, 0, 0.3);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: linear-gradient(135deg, #ffae00 0%, #e36e00 100%);
    box-shadow: 0 8px 25px rgba(227, 110, 0, 0.4);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: rgba(156, 163, 175, 0.5);
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  @media (max-width: 768px) {
    min-width: 100%;
    font-size: 13px;
    height: 44px;
  }
`;

const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 8px;
  }
`;

const RadioGroupContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

const SegmentedToggle = styled.div`
  display: flex;
  width: ${({ wide }) => (wide ? "220px" : "120px")};
  height: 40px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 999px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  border: 1px solid rgba(227, 110, 0, 0.12);

  @media (max-width: 768px) {
    width: ${({ wide }) => (wide ? "180px" : "100px")};
    height: 36px;
  }
`;

const SegmentedToggleButton = styled.button`
  flex: 1;
  height: 100%;
  border: none;
  outline: none;
  background: ${({ selected }) =>
    selected ? theme.gradient.themeGradient : "rgba(255,255,255,0.7)"};
  color: ${({ selected }) => (selected ? "#fff" : theme.colors.themeColor)};
  font-weight: 600;
  font-size: 14px;
  font-family: inherit;
  border-radius: 999px;
  box-shadow: ${({ selected }) =>
    selected ? "0 4px 16px rgba(227, 110, 0, 0.10)" : "none"};
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1;
  letter-spacing: 0.5px;

  &:hover {
    filter: brightness(0.98);
    box-shadow: ${({ selected }) =>
      selected
        ? "0 6px 20px rgba(227, 110, 0, 0.15)"
        : "0 2px 8px rgba(227, 110, 0, 0.05)"};
  }

  @media (max-width: 768px) {
    font-size: 12px;
    height: 32px;
  }
`;

const SC = {
  Label,
  Astrik,
  LabelContainer,
  Children,
  Wrapper,
  ReportContainer,
  ResponsiveButtonContainer,
  StyledButton,
  SwitchContainer,
  RadioGroupContainer,
  SegmentedToggle,
  SegmentedToggleButton,
};

export default SC;
